import React from 'react'
import Steps from "../../steps/steps";

export default function NewClaimSteps(props) {
    const stepProps = [
        {
            active: false,
            completed: false,
            disabled: true,
            label: "What happened",
            subLabel: '"What had happened was..."'
        },
        {
            active: false,
            completed: false,
            disabled: true,
            label: "Upload",
        },
        {
            active: false,
            completed: false,
            disabled: true,
            label: "Payment preference",
        },
        {
            active: false,
            completed: false,
            disabled: true,
            label: "Review",
        }
    ];

    const {activeStepIdx} = props;
    for (let i = 0; i < activeStepIdx; i++) {
        stepProps[i].disabled = false;
        stepProps[i].completed = true;
    }
    stepProps[activeStepIdx].active = true;
    stepProps[activeStepIdx].disabled = false;

    return (
        <Steps stepProps={stepProps}/>
    )
}